import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import {translate} from "react-i18next";

import Step from './Step';
import { editAddressClick, editPassportAddressClick } from '../../../Modal/SettingsModal/ProfileSettings/actions';
import FloatingLabelInput from '../../../common/FloatingLabelInput';
import FloatingLabelSelect from '../../../common/FloatingLabelSelect';

@translate(['register'], {wait:true})
class AddressStep extends Step {
  constructor(props) {
    super(props);

    this.state = {
      address: {
        subject: 'неизвестно',
        region: '',
        cityType: '',
        cityName: '',
        streetName: '',
        village: '',
        building: '',
        corpus: '',
        vladenie: '',
        stroenie: '',
        flat: '',
        postCode: '',
        isNew: props.addressIsNew
      },
      passportAddress: {
        subject: 'неизвестно',
        region: '',
        cityType: '',
        cityName: '',
        streetName: '',
        village: '',
        building: '',
        corpus: '',
        vladenie: '',
        stroenie: '',
        flat: '',
        postCode: '',
        isNew: props.addressIsNew
      },
      isSame: true,
    };
  }

  handleBackClick(e) {
    e.preventDefault();
    this.props.decreaseStepIndex()
  }

  handleNextClick(e) {
    e.preventDefault();
    const passportAddress = this.state.passportAddress;
    const address = this.state.isSame ? this.state.passportAddress : this.state.address;
    this.props.increaseStepIndex()
    this.props.handleAddressSave(address);
    this.props.handlePassportAddressSave(passportAddress);
  }

  render() {
    const {t} = this.props;
    return (
      <div className="container">
        <a onClick={this.handleBackClick} className="backStep" href=""></a>
        <form className="popupForm popupRegistrationForm addressStep" action="#">
          <div className="stepTitle">
            <h2>{t('register:reg_address')}</h2>
          </div>
          <div className="popupForm__body">
            <div className="row colRow">
              <div className="col ccityname"><FloatingLabelInput type="text" label={t('register:cityname')} onChange={e => {
                const passportAddress = this.state.passportAddress;

                this.setState({
                  passportAddress: {
                    ...passportAddress,
                    cityName: e.target.value,
                  },
                });
              }}/></div>
              <div className="col postcode"><FloatingLabelInput type="text" label={t('register:postcode')} onChange={e => {
                const passportAddress = this.state.passportAddress;

                this.setState({
                  passportAddress: {
                    ...passportAddress,
                    postCode: e.target.value,
                  },
                });
              }}/></div>
            </div>
            <div className="row"><FloatingLabelInput type="text" label={t('register:streetname')} onChange={e => {
              const passportAddress = this.state.passportAddress;

              this.setState({
                passportAddress: {
                  ...passportAddress,
                  streetName: e.target.value,
                },
              });
            }}/></div>
            <div className="row colRow">
              <div className="col col-4">
                <FloatingLabelInput type="text" label={t('register:building')} onChange={e => {
                  const passportAddress = this.state.passportAddress;

                  this.setState({
                    passportAddress: {
                      ...passportAddress,
                      building: e.target.value,
                    },
                  });
                }}/>
              </div>
              <div className="col col-4">
                <FloatingLabelInput type="text" label={t('register:corpus')} onChange={e => {
                  const passportAddress = this.state.passportAddress;

                  this.setState({
                    passportAddress: {
                      ...passportAddress,
                      corpus: e.target.value,
                    },
                  });
                }}/>
              </div>
              <div className="col col-4">
                <FloatingLabelInput type="text" label={t('register:flat')} onChange={e => {
                  const passportAddress = this.state.passportAddress;

                  this.setState({
                    passportAddress: {
                      ...passportAddress,
                      flat: e.target.value,
                    },
                  });
                }}/>
              </div>
            </div>
            <div className="row">
              <label className="checkbox"><input defaultChecked className="hasNewAddressCheckbox" type="checkbox" onChange={e => this.setState({isSame: e.target.checked})}/><span>{t('register:same_as_living_address')}</span></label>
            </div>
            {
              !this.state.isSame ?
              <div>
                <h4>{t('register:living_address')}</h4>
                <div className="row colRow">
                  <div className="col ccityname"><FloatingLabelInput type="text" label={t('register:cityname')} onChange={e => {
                    const address = this.state.address;

                    this.setState({
                      address: {
                        ...address,
                        cityName: e.target.value,
                      },
                    });
                  }}/></div>
                  <div className="col postcode"><FloatingLabelInput type="text" label={t('register:postcode')} onChange={e => {
                    const address = this.state.address;

                    this.setState({
                      address: {
                        ...address,
                        postCode: e.target.value,
                      },
                    });
                  }}/></div>
                </div>
                <div className="row"><FloatingLabelInput type="text" label={t('register:streetname')} onChange={e => {
                  const address = this.state.address;

                  this.setState({
                    address: {
                      ...address,
                      streetName: e.target.value,
                    },
                  });
                }}/></div>
                <div className="row colRow">
                  <div className="col col-4">
                    <FloatingLabelInput type="text" label={t('register:building')} onChange={e => {
                      const address = this.state.address;

                      this.setState({
                        address: {
                          ...address,
                          building: e.target.value,
                        },
                      });
                    }}/>
                  </div>
                  <div className="col col-4">
                    <FloatingLabelInput type="text" label={t('register:corpus')} onChange={e => {
                      const address = this.state.address;

                      this.setState({
                        address: {
                          ...address,
                          corpus: e.target.value,
                        },
                      });
                    }}/>
                  </div>
                  <div className="col col-4">
                    <FloatingLabelInput type="text" label={t('register:flat')} onChange={e => {
                      const address = this.state.address;

                      this.setState({
                        address: {
                          ...address,
                          flat: e.target.value,
                        },
                      });
                    }}/>
                  </div>
                </div>
              </div> : null
            }
          </div>
          <div className="rowButton">
            <button
            onClick={(e) => {
              e.preventDefault();
              this.handleNextClick(e);
              this.setState({isFormSubmitted: true});
            }} className="btn"><span>{t('register:continue')}</span></button>
          </div>
        </form>
      </div>
    );
  }
}

AddressStep.propTypes = {
  handleAddressSave: PropTypes.func,
  handlePassportAddressSave: PropTypes.func,
  addressErrors: PropTypes.array,
  passportAddressErrors: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      addressErrors: state.settings.addressErrors,
      passportAddressErrors: state.settings.passportAddressErrors,
    };
  },
  (dispatch) => {
    return {
      handleAddressSave(address) {
        return dispatch(editAddressClick({
          address: {
            ...address,
          },
        }));
      },
      handlePassportAddressSave(passportAddress) {
        return dispatch(editPassportAddressClick({
          address: {
            ...passportAddress,
          },
        }));
      },
    };
  },
)(AddressStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/AddressStep.js